import React, { Component } from 'react';
import * as microsoftTeams from '@microsoft/teams-js';
import { connect } from 'react-redux';
import { getFilterData, getSelectedCard, updateFilter, setCardLibraryMessage, updateChartViewState } from '../../actions/card-library.actions';
import TeamsCard from '../team-card/team-card';
import { Button, Header, Menu, Message, Popup, Segment,Image } from 'semantic-ui-react';
import { CONFIG } from '../../helper/config';
import FilterPopup from './filter-popup/filter-popup';
import { FilterData, FilterInfo } from '../../modal/filters';
import { storeSessionId } from '../../actions/view.actions';
import NarrativeBoardDropdown from '../narrative-board/narrative-board-dropdown/narrative-board-dropdown';
import CreateNotification from '../notifications/create-notification/create-notification';
import _ from 'lodash';
import ErrorFallback from '../common/error-boundary/error-boundary';
import './card-library.css'
import { IMAGECONFIG } from '../../helper/image-config';
import { Link } from 'react-router-dom';

/**
 * Props for the BeagleCards component.
 */
interface IProps {
  getFilterData: (arg0: any, arg2: string, auth_token: string) => void;
  getSelectedCard: (arg0: any, auth_token: string) => void;
  updateFilter: (arg0: any, arg1: string, auth_token: string) => void;
  setCardLibraryMessage: (msg: string) => void;
  updateChartViewState: (is_update_chart_view_state: boolean) => void;
  storeSessionId :(arg0:string) => void;
  teams_filter: {};
  table_data: any;
  //unique_table_data: any;
  template_config: any;
  template: any;
  is_license_expire: boolean;
  dependent_filter_data: FilterData;
  card_library_msg: string;
  theme: string;
  sequence_id: any;
  file_name: string;
  is_update_chart_view_state: boolean;
  fallback_ui:boolean;
  access_revoke_fallback_ui:boolean;
  token_fallback_ui:boolean;
  token_fallback_details:any;
  render_narrative_board:boolean;
}

/**
 * State for the BeagleCards component.
 */
interface IState {
  team_context: any;
  team_context_info: any;
  port_no: any;
  token: any;
  file_name: any;
  open_popup: string;
  popup_open:boolean;
  // is_show_notification_success: boolean;
  action_button_div_height: number;
  va_id:any;
  webAppData:any;
}

/**
 * BeagleCards Component
 *
 * Responsible for rendering the card library UI inside Microsoft Teams or a web application.
 * Handles authentication, context fetching, filter management, notifications,
 * narrative boards, and error fallbacks.
 */
export class BeagleCards extends Component<IProps, IState> {
  /** Ref for measuring action button container height */
  display_action_button_ref: any = React.createRef();

  /** Resize timer used for throttling resize callbacks */
  resize_callback_timer: any = null;

  /** Timer used for auto-clearing messages */
  timer: any = null;

  constructor(props: IProps) {
    super(props);
    this.state = {
      team_context: {},
      team_context_info: {},
      port_no: '',
      token: '',
      file_name: '',
      open_popup: '',
      popup_open: true,
      action_button_div_height: 0,
      va_id: '',
      webAppData: {}
    }
  }

  /**
   * Called when the component has been mounted.
   * Handles the logic for both Teams and WebApp.
   * For Teams:
   * - Initializes the Microsoft Teams app.
   * - Gets the context (channel, team, user, etc.).
   * - Gets the auth token.
   * - Calls the getFilterData and getSelectedCard actions.
   * - Sets the component state.
   * For WebApp:
   * - Listens for the message event.
   * - Parses the query parameters.
   * - Calls the getFilterData and getSelectedCard actions.
   * - Sets the component state.
   */
  componentDidMount() {
    const query_params = window.location.search.split('?')[1];
    let isWebApp = query_params ? query_params.split(CONFIG.URLQUERYPARAMSEPERATOR)[5]:"";
    const port_no: any = query_params ? query_params.split(CONFIG.URLQUERYPARAMSEPERATOR)[0] : '';
    const file_name: any = query_params ? query_params.split(CONFIG.URLQUERYPARAMSEPERATOR)[1] : '';
    if(query_params && query_params.split(CONFIG.URLQUERYPARAMSEPERATOR)[6]===CONFIG.WEBAPP && isWebApp==="notify_me"){
    isWebApp=CONFIG.WEBAPP
    }
    console.log('port No', port_no);
    console.log('File Name', file_name);
    console.log("isWebApp",isWebApp)
    if(isWebApp!==CONFIG.WEBAPP){
    microsoftTeams.app.initialize();
    microsoftTeams.app.notifySuccess();
    let team_context: any = {};
    microsoftTeams.app.getContext().then((context) => {
      console.log('context', context);

      team_context.user_id = context.user?.id;
      team_context.user_name = context.user?.userPrincipalName;
      team_context.tenant_id = context.user?.tenant?.id;
      team_context.file_name = file_name;
      team_context.teams_channel_id = context.channel?.id;
      team_context.channelId = 'msteams';

      microsoftTeams.authentication.getAuthToken().then((token: string) => {
          let info = {
            va_id: query_params ? query_params.split(CONFIG.URLQUERYPARAMSEPERATOR)[2] : '',
            platform:"teams",
            port_no: port_no, ...team_context
          };
          let sessionId= new Date().toString();
          let notify_me_msg = query_params ? query_params.split(CONFIG.URLQUERYPARAMSEPERATOR)[5] : '';
          this.setState({va_id:info.va_id})
          this.props.storeSessionId(sessionId)
          if (notify_me_msg !== CONFIG.NOTIFICATION.NOTIFYME) {
            this.props.getFilterData(info, port_no, token)
          }
          this.props.getSelectedCard(info, token);

          this.setState({
            team_context: team_context, port_no: port_no,
            token: token, file_name: file_name,
            action_button_div_height: 20,team_context_info:info
          })
        }).catch((reason: string) => {
          console.error('reason :: ', reason);
        })
      })

    this.updateActionButtonContainerDimension();
    window.addEventListener('resize', this.updateActionButtonContainerDimension);

  }else{
    let webAppData;
    const handleMessage = (event) => {
        if (event.origin !== event?.data?.parentUrl) return;
        webAppData = { ...event.data };
        const token = webAppData.token
        const info = {
          "va_id": query_params ? query_params.split(CONFIG.URLQUERYPARAMSEPERATOR)[2] : '',
          "port_no": port_no,
          "user_id": webAppData.aad_object_id,
          "user_name": webAppData.email,
          "tenant_id": webAppData.tenantId,
          "file_name": file_name,
          "channelId": "msteams",
          "platform":"webapp"
      }  
      let notify_me_msg = query_params ? query_params.split(CONFIG.URLQUERYPARAMSEPERATOR)[5] : '';
      if (notify_me_msg !== CONFIG.NOTIFICATION.NOTIFYME) {
        this.props.getFilterData(info, port_no, token)
      }
      this.props.getSelectedCard(info, token);
        this.setState({
         port_no: port_no,
          token: token, file_name: file_name,
          action_button_div_height: 20,
          team_context:info,
          team_context_info:info,
          webAppData:webAppData
        })
    }
    window.addEventListener('message', handleMessage);
  }
  }

  /**
   * This function is called after the component has updated.
   * It checks if the `display_action_button_ref` element exists and if it does, it checks if the height of the element
   * has changed. If the height has changed, it updates the state with the new height.
   */
  componentDidUpdate() {
    if ( this.display_action_button_ref?.current) {
      let height = this.display_action_button_ref.current.offsetHeight - 30;
      if (this.state.action_button_div_height !== height) {
        this.setState({ action_button_div_height: height });
      }
    }
  }

  /**
   * Called when the component is about to be unmounted.
   * Removes the event listener for the window resize event and clears the timer.
   */
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateActionButtonContainerDimension);
    if (this.timer) {
        clearTimeout(this.timer);
    }
  }

  /**
   * This function is called on window resize event. It checks if the height of the action button container has changed.
   * If the height has changed, it updates the state with the new height.
   * The function uses a timer to call the function after a short delay (1ms) to avoid excessive calls on
   * window resize event.
   */
  updateActionButtonContainerDimension = () => {
    if (this.resize_callback_timer) {
      clearTimeout(this.resize_callback_timer);
    }
    this.resize_callback_timer = setTimeout(() => {
      if ( this.display_action_button_ref?.current) {
        let { action_button_div_height } = this.state;
        let curr_height = this.display_action_button_ref.current.offsetHeight - 30;
        if (action_button_div_height !== curr_height) {
          this.setState({ action_button_div_height: curr_height });
        }
      }
    }, 1);
  };

  /**
   * This function is called when the user submits the filters.
   * It updates the template config with the new filter columns and time period filters.
   * If the time period filter is not already in the template config, it adds it.
   * It then calls the updateFilter action with the new info and closes the popup.
   * @param {FilterInfo[]} filter_columns The new filter columns.
   * @param {any} timePeriodFilters The new time period filters.
   */
  submitFilters = (filter_columns: FilterInfo[], timePeriodFilters: any) => {
    let { template_config, template, dependent_filter_data: { time_period_filter_data } } = this.props;
    let { port_no, token } = this.state;
    let info = JSON.parse(JSON.stringify(this.state.team_context));
    info.filter_columns = filter_columns.slice();
    if (template_config.time_period_filter && Object.keys(template_config.time_period_filter).length > 0) {
      if (!_.isEqual(template_config.time_period_filter.values, timePeriodFilters)) {
        template_config.time_period_filter.values = timePeriodFilters;
        template_config.nlp_time_period_filter = {}
      }
    } else if ( time_period_filter_data?.property?.id) {
      template_config.time_period_filter = {
        column_id: time_period_filter_data.property.id,
        name: time_period_filter_data.property.name,
        values: timePeriodFilters
      }
      template_config.nlp_time_period_filter = {}
    }
    info.template_config = template_config;
    info.template = template;
    const query_params = window.location.search.split('?')[1];
    info.va_id = query_params ? query_params.split(CONFIG.URLQUERYPARAMSEPERATOR)[2] : '';
    this.props.updateFilter(info, port_no, token);
    this.closePopup();
  }

  /**
   * Closes the currently open popup by resetting `open_popup` state.
   */
  closePopup = () => {
    this.setState({ open_popup: '' });
  }

  /**
   * Renders a dismissible error/info message at the top of the component.
   * Clears the message after 5 seconds automatically.
   *
   * @returns {React.ReactElement | null} The message component or null if no message is set.
   */
  renderMessage = () => {
    let { card_library_msg } = this.props;
    console.log('card_library_msg', card_library_msg);
    if (this.timer) {
        clearTimeout(this.timer);
    }
    if ( card_library_msg&&card_library_msg!==undefined && card_library_msg?.trim() !== '') {
      this.timer=  setTimeout(() => {
            this.props.setCardLibraryMessage('');
        }, 5000);

      return <div id='narrative-board-message-container' style={{ width: '60%' }} >
        <Message error content={card_library_msg} onDismiss={() => this.props.setCardLibraryMessage('')} />
      </div>
    } else {
      return null;
    }
  }

  /**
   * Retrieves the current template name from props.
   *
   * @returns {string} The template name or an empty string if not available.
   */
  templateName = () => {
    let { template_config } = this.props;
    return template_config ? template_config.name : ''
  }

  /**
   * Renders the action buttons for the card library.
   * @returns {React.ReactElement} The rendered action buttons.
   */
  renderActionButtons = () => {
    let buttons: any[] = [];
    let {popup_open}=this.state;
    let {dependent_filter_data,template_config,render_narrative_board}=this.props;
    const query_params = window.location.search.split('?')[1];
    let demo = query_params ? query_params.split(CONFIG.URLQUERYPARAMSEPERATOR)[5] : '';
    if (demo.toLowerCase() === 'demo') {
      buttons.push({ text: CONFIG.BUTTONTEXT.FILTERS, id: 'filter-popup' });
    } else if (template_config.id) {
        if(dependent_filter_data.filter_columns && dependent_filter_data.render_filters){
            buttons.push({ text: CONFIG.BUTTONTEXT.FILTERS, id: 'filter-popup' });
           }
           if(dependent_filter_data.render_notification){
            buttons.push({ text: CONFIG.BUTTONTEXT.NOTIFYME, id: 'notification-popup' });
           }
        if(dependent_filter_data.render_narrative_board || render_narrative_board){
          buttons.push({ text: CONFIG.BUTTONTEXT.NARRATIVEBOARD, id: 'narrative-board-popup' });
         }
        }
      else {
        let notify_me_msg = window.location.search.split('?')[1] ? window.location.search.split('?')[1].split(CONFIG.URLQUERYPARAMSEPERATOR)[5] : '';
        if (notify_me_msg === CONFIG.NOTIFICATION.NOTIFYME){
          buttons = []
          if(dependent_filter_data?.render_narrative_board || render_narrative_board){
            buttons.push({ text: CONFIG.BUTTONTEXT.NARRATIVEBOARD, id: 'narrative-board-popup' });
           }
        }
      }

    return buttons.map((btn, i) => (
      <Popup key={btn} id={btn.id}
        on={'click'} pinned wide
        open={this.state.open_popup === btn.text}
        position={'bottom center'}
        closeOnDocumentClick={popup_open}
        closeOnEscape={true}
        onClose={() => this.closePopup()}
        trigger={<Button id={`${btn.id}-btn`} data-testid="filter-btn"
          basic={btn.text !== CONFIG.BUTTONTEXT.FILTERS}
          primary content={btn.text}
          onClick={() => this.setState({ open_popup: btn.text })} />}
      >
        <Popup.Content className={`theme-${this.props.theme}`} >
          {this.renderPopupContent(btn.text)}
        </Popup.Content>
      </Popup>
    ))
  }

  /**
   * Retrieves the currently applied time period filters from the template configuration.
   *
   * @returns {any[]} An array of applied time period filter values.
   */
  appliedTimePeriodFilters = () => {
    let { template_config } = this.props;
    if (Object.keys(template_config.time_period_filter ? template_config.time_period_filter : []).length > 0) {
      return template_config.time_period_filter.values;
    } else return []
  }


   /**
   * Renders the content for a popup depending on the selected button.
   *
   * @param {string} btn_text - The text identifier of the button clicked.
   * @returns {React.ReactElement} The rendered popup content.
   */
  renderPopupContent = (btn_text: string) => {
    let { sequence_id, file_name, template_config } = this.props;
    switch (btn_text) {
      case CONFIG.BUTTONTEXT.FILTERS:
        return <FilterPopup
        template_config={template_config}
          filter_data={this.props.dependent_filter_data}
          appliedTimePeriodFilters={this.appliedTimePeriodFilters()}
          submitFilters={this.submitFilters} token={this.state.token} team_context={this.state.team_context} va_id={this.state.va_id}/>

      case CONFIG.BUTTONTEXT.NOTIFYME:
        return <CreateNotification notify_me_from_inside={true}
          template_config={template_config}
          sequence_id={sequence_id} file_name={file_name} team_context={this.state.team_context} webAppData={this.state.webAppData}/>

      case CONFIG.BUTTONTEXT.NARRATIVEBOARD:
        return <NarrativeBoardDropdown template_config={template_config}
          notify_me_from_inside={true} sequence_id={sequence_id}/>

      default:
        return <></>
    }
  }

  /**
   * render
   *
   * Renders the component
   *
   * If the license has expired, it will render a message to the user
   * Otherwise, it will render the following components:
   * - A message depending on the props
   * - A menu with action buttons
   * - A TeamsCard component if the user is logged in and not in fallback mode
   * - An image with a message if the user is in access revoke fallback mode
   * - An error fallback component if the user is in fallback mode
   * @return {React.ReactElement} The rendered component
   */
  render() {
    const {
      template_config,
      table_data,
      teams_filter,
      is_license_expire,
      is_update_chart_view_state,
      fallback_ui,
      access_revoke_fallback_ui,
      token_fallback_ui,
      token_fallback_details
    } = this.props;
    if (is_license_expire) {
      return <Segment placeholder textAlign="center" size="large" content={CONFIG.LICENSE_EXPIRE} />
    }
    else {
      return (
        <>
          {this.renderMessage()}
          {this.state.team_context.user_id  || table_data ?
            <div ref={this.display_action_button_ref} >
              <Menu secondary id='action-buttons-menu' >
                <Header as='h4' content={this.templateName()} />
                <Menu.Menu position='right' >
                  <Button.Group >
                    {this.renderActionButtons()}
                  </Button.Group>
                </Menu.Menu>
              </Menu>
            </div>
            : null
          }
          {!fallback_ui && !access_revoke_fallback_ui && !token_fallback_ui? <TeamsCard
            is_update_chart_view_state={is_update_chart_view_state}
            updateChartViewState={this.props.updateChartViewState}
            template_config={template_config}
            table_data={table_data}
            teams_filter={teams_filter}
            action_button_div_height={this.state.action_button_div_height}
          ></TeamsCard>:null}
          {access_revoke_fallback_ui?  
          <div className='access_fallback'><Image src={IMAGECONFIG.ACCESSFALLBACK} alt='Access Revoke Image'/><div className='fallback_content'>{CONFIG.ACCESSREVOKED}</div></div>:
          null}

        { (token_fallback_ui || Object.keys(token_fallback_details).length > 0)? <div className='token_fallback'>
          <Image src={token_fallback_details?.fallback_image_file_name_path} alt='token_fallback_image'/>
            <h2>Having trouble accessing this card?</h2>
          <p>This issue is commonly caused by problems with the Microsoft Teams app cache.</p>

       <h3 style={{marginBottom:'0'}}>Recommended solutions:</h3>
       <ul style={{marginTop:'5px'}}>
       <li>Sign out and sign back into Teams.</li>

       <li>If the issue persists, try clearing your Teams cache by following these steps:  <Link to='https://learn.microsoft.com/en-gb/troubleshoot/microsoftteams/teams-administration/clear-teams-cache'>How to clear your Microsoft Teams cache</Link></li>
       </ul>
       <div><span>For further support, please contact </span><span style={{fontWeight:'bold'}}> IT for general assistance</span> or message <span style={{fontWeight:'bold'}}>Beagle PM: </span><Link to={`mailto:${token_fallback_details?.contact_email}`}>{token_fallback_details?.contact_email}</Link></div>
           </div>:null}
          { fallback_ui?<ErrorFallback/>:null}
        </>
      );
    }

  }
}

/**
 * Maps state to props for the CardLibrary component.
 * Retrieves the template, table_data, template_config, teams_filter, is_license_expire, dependent_filter_data, card_library_msg, theme, sequence_id, file_name, is_update_chart_view_state, fallback_ui, access_revoke_fallback_ui, and render_narrative_board from the card library state.
 * @param {Object} state - The state of the application.
 * @returns {Object} A props object containing the template, table_data, template_config, teams_filter, is_license_expire, dependent_filter_data, card_library_msg, theme, sequence_id, file_name, is_update_chart_view_state, fallback_ui, access_revoke_fallback_ui, and render_narrative_board.
 */
const mapStateToProps = (state: any) => {
  const { beagle_card, dependent_filter_data, card_library_msg, is_update_chart_view_state,fallback_ui,access_revoke_fallback_ui,token_fallback_ui,token_fallback_details } = state.cardLibraryState;
    return {
    template: beagle_card.template ? JSON.parse(JSON.stringify(beagle_card.template)) : {},
    table_data: beagle_card.table_data ? JSON.parse(JSON.stringify(beagle_card.table_data)) : [],
    //unique_table_data: beagle_card.unique_table_data ? JSON.parse(JSON.stringify(beagle_card.unique_table_data)) : [],
    template_config: beagle_card.template_config ? JSON.parse(JSON.stringify(beagle_card.template_config)) : {},
    teams_filter: beagle_card.teams_filter ? JSON.parse(JSON.stringify(beagle_card.teams_filter)) : [],
    is_license_expire: state.viewState.is_license_expire,
    dependent_filter_data: dependent_filter_data,
    card_library_msg: card_library_msg,
    theme: state.viewState.theme,
    sequence_id: beagle_card.sequence_id,
    file_name: beagle_card.file_name,
    is_update_chart_view_state: is_update_chart_view_state,
    fallback_ui,
    token_fallback_ui,
    token_fallback_details,
    access_revoke_fallback_ui,
    render_narrative_board:beagle_card?.render_narrative_board ||false
  };
};

export default connect(mapStateToProps, { getFilterData, getSelectedCard, updateFilter, setCardLibraryMessage, updateChartViewState,storeSessionId })(BeagleCards);